<template>
  <b-modal
    id="modal-update-properties"
    ref="modal"
    cancel-variant="outline-secondary"
    ok-title="Save"
    cancel-title="Cancel"
    centered
    title="Update Properties"
    size="lg"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <div>
      <div>
        <b-form
          ref="form"
          :style="{height: trHeight}"
          class="repeater-form"
          @submit.prevent="handleSubmit"
        >

          <!-- Row Loop -->
          <b-row
            v-for="(item, index) in items"
            :id="item.id"
            :key="item.id"
            ref="row"
          >

            <!-- Item Name -->
            <b-col lg="4">
              <b-form-group
                label="Property Name"
                label-for="property-name"
                invalid-feedback="Name is required"
                :state="items[index].property.name !== ''"
              >
                <b-form-input
                  id="property-name"
                  v-model="items[index].property.name"
                  type="text"
                  placeholder="Property Name"
                  required
                />
              </b-form-group>
            </b-col>

            <!-- Value -->
            <b-col lg="2">
              <b-form-group
                label="Value"
                label-for="property value"
                invalid-feedback="Value is required"
                :state="items[index].property.value !== ''"
              >
                <b-form-input
                  id="Property Value"
                  v-model="items[index].property.value"
                  type="text"
                  placeholder="32"
                  required
                />
              </b-form-group>
            </b-col>

            <!-- Unit  -->
            <b-col lg="3">
              <b-form-group
                label="Unit"
                label-for="unit"
              >
                <b-form-input
                  id="unit"
                  v-model="items[index].property.unit"
                  type="text"
                  placeholder="m / cm / kg / C"
                />
              </b-form-group>
            </b-col>

            <!-- Remove Button -->
            <b-col
              lg="3"
              class="mb-50"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeItem(index)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
                <span>Delete</span>
              </b-button>
            </b-col>
            <b-col cols="12">
              <hr>
            </b-col>
          </b-row>

        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import {
  API,
} from 'aws-amplify'
import * as mutations from '../../../graphql/mutations'
// import vSelect from 'vue-select' en kommentar

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BModal,
    // vSelect,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    objectProperties: {
      type: Array,
      required: true,
    },
    object: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [{
        id: 1,
        property: {
          id: '',
          name: '',
          value: '',
          unit: '',
        },
      }],
      nextTodoId: 2,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
    if (this.objectProperties.length > 0) {
      this.items = []
      this.objectProperties.forEach((property, index) => {
        this.items.push({
          id: index + 1,
          property,
        })
      })
    }

    // this.items = this.objectProperties
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        property: {
          id: '',
          name: '',
          value: '',
          unit: '',
        },
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return
      }
      const properties = []
      this.items.forEach(item => properties.push(item.property))
      const updateProperties = {
        id: this.object.id,
        properties: JSON.stringify(properties),
      }
      await API.graphql({
        query: mutations.updateObject,
        variables: {
          input: updateProperties,
        },
      })
      this.$nextTick(() => {
        this.$bvModal.hide('modal-update-properties')
      })
      window.location.reload()
    },
    resetModal() {
      if (this.objectProperties.length > 0) {
        this.items = []
        this.objectProperties.forEach((property, index) => {
          this.items.push({
            id: index + 1,
            property,
          })
        })
      } else {
        this.items = [{
          id: 1,
          property: {
            id: '',
            name: '',
            value: '',
            unit: '',
          },
        }]
      }
    },

  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
